"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var YouTube = function YouTube(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "youtube",
    viewBox: "0 0 32 32"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-228.000000, -518.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, react_1["default"].createElement("g", {
    id: "Group-11",
    transform: "translate(60.000000, 518.000000)"
  }, react_1["default"].createElement("g", {
    id: "Youtube",
    transform: "translate(168.000000, 0.000000)"
  }, react_1["default"].createElement("path", {
    d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M24.1766788,12.0488129 C23.9804121,11.2948086 23.4020849,10.7010623 22.6677333,10.4995527 C21.3369212,10.1333333 16,10.1333333 16,10.1333333 C16,10.1333333 10.6630788,10.1333333 9.33216971,10.4995527 C8.59781819,10.7010623 8.01949093,11.2948086 7.82322427,12.0488129 C7.46666667,13.4153591 7.46666667,16.2666667 7.46666667,16.2666667 C7.46666667,16.2666667 7.46666667,19.1178753 7.82322427,20.4845204 C8.01949093,21.2385247 8.59781819,21.832271 9.33216971,22.0338796 C10.6630788,22.4 16,22.4 16,22.4 C16,22.4 21.3369212,22.4 22.6677333,22.0338796 C23.4020849,21.832271 23.9804121,21.2385247 24.1766788,20.4845204 C24.5333333,19.1178753 24.5333333,16.2666667 24.5333333,16.2666667 C24.5333333,16.2666667 24.5333333,13.4153591 24.1766788,12.0488129 Z",
    id: "Combined-Shape"
  }), react_1["default"].createElement("polygon", {
    id: "Fill-2",
    points: "14.4 19.2 14.4 13.8666667 18.6666667 16.5334353"
  }))))));
};

exports["default"] = YouTube;